import img1 from '../assets/Products/iorxuhfensblqhn6jy5d.png'
import img2 from '../assets/Products/ousbxxs7ohhddd3wz18k.png'
import img3 from '../assets/Products/vx64ovkpz9nu98tqdtzn.png'

export default [
  {
    "id": 1,
    "title": "mac vintage computer",
    "price": 200.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img1,
    "amount": 3,
    "featured": true
  },
  {
    "id": 2,
    "title": "compaq vintage computer",
    "price": 40.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img2,
    "amount": 5,
    "featured": false
  },
  {
    "id": 3,
    "title": "commodore 64 vintage computer",
    "price": 129.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img3,
    "amount": 4,
    "featured": false
  },
  {
    "id": 4,
    "title": "mac vintage computer",
    "price": 200.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img1,
    "amount": 3,
    "featured": false
  },
  {
    "id": 5,
    "title": "compaq vintage computer",
    "price": 40.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img2,
    "amount": 5,
    "featured": false
  },
  {
    "id": 6,
    "title": "commodore 64 vintage computer",
    "price": 129.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img3,
    "amount": 4,
    "featured": false
  },
  {
    "id": 7,
    "title": "mac vintage computer",
    "price": 200.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img1,
    "amount": 3,
    "featured": false
  },
  {
    "id": 8,
    "title": "compaq vintage computer",
    "price": 40.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img2,
    "amount": 5,
    "featured": true
  },
  {
    "id": 9,
    "title": "commodore 64 vintage computer",
    "price": 129.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img3,
    "amount": 4,
    "featured": false
  },
  {
    "id": 10,
    "title": "mac vintage computer",
    "price": 200.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img1,
    "amount": 3,
    "featured": true
  },
  {
    "id": 11,
    "title": "compaq vintage computer",
    "price": 40.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img2,
    "amount": 5,
    "featured": false
  },
  {
    "id": 12,
    "title": "commodore 64 vintage computer",
    "price": 129.99,
    "description": 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem beatae sed voluptatem illo impedit recusandae quod! Sint maxime provident vel illo autem atque, rerum quibusdam deserunt sed dolorem repudiandae! Commodi error rerum ut hic vel? Officiis, autem? Repellat, tenetur. Fugit voluptatibus velit minus consectetur cupiditate suscipit ducimus odio, dolor possimus.',
    "image": img3,
    "amount": 4,
    "featured": true
  }
]